import { render } from "./orders-tabs.vue?vue&type=template&id=40c49ee6&ts=true"
import script from "./orders-tabs.vue?vue&type=script&lang=ts"
export * from "./orders-tabs.vue?vue&type=script&lang=ts"

import "./orders-tabs.vue?vue&type=style&index=0&id=40c49ee6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__